<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="normal"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      no-padding
      @cancel="cancel"
      @confirm="confirm">
    <template #header>保存模板</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-width="135px"
          style="padding: 16px 10px 0;">
        <el-form-item
            label="模板名称"
            prop="name"
            :rules="[
              { required: true, message: '请输入模板名称', trigger: ['change'] }
            ]">
          <gj-input
              v-model="form.name"
              width="250px">
          </gj-input>
        </el-form-item>
        <el-form-item
            label="是否共享">
          <el-radio-group v-model="form.share">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formValidatorMixin, modalMixIn} from "../../../../../../../../minxins";

  export default {
    name: "app-save-strategy-tpl-modal",
    mixins: [modalMixIn, formValidatorMixin],
    props: {},
    data() {
      return {
        form: {
          name: null,
          share: false
        }
      }
    },
    methods: {
      confirm() {
        if (this.formValidate()) {
          this.confirmLoading = true;
          this.$emit('save', this.form);
        }
      }
    }
  }
</script>

<style scoped>

</style>

